import React from "react";
import classNames from "classnames";
import { AvatarCircle } from "Components/AvatarCircle";
import { useMemberPicture, UserPictureCache } from "Hooks";
import { User } from "./User";
import classes from "./UserInfo.module.scss";

interface UserInfoProps
   extends React.InputHTMLAttributes<HTMLInputElement> {
   userPictureCache: UserPictureCache;
   user?: User;
   className?: string;
   bsSize?: "lg" | "sm";
}

const UserInfo: React.FC<UserInfoProps> = ({
   userPictureCache,
   user,
   bsSize,
   className,
   ...props
}) => {
   const title = user?.fullName || user?.email;
   const subtitle = user?.fullName && user?.email;
   const memberPicture = useMemberPicture(userPictureCache, user?.id);

   return (
      <div className={classNames(classes.userInfo, className)} {...props}>
         {bsSize !== "sm" && (
            <AvatarCircle imageUrl={memberPicture} firstName={title} colorIndex={0} />
         )}
         <div className={classes.userInfoTextContainer}>
            <div className={classes.userInfoTitle}>{title}</div>
            {subtitle && bsSize !== "sm" && (
               <div className={classes.userInfoSubtitle}>{subtitle}</div>
            )}
         </div>
      </div>
   );
};

export default UserInfo;
